import React, { Fragment } from 'react';
import PropTypes from 'prop-types';
import classNames from 'classnames/bind';
import styles from './styles.scss';

const cx = classNames.bind(styles);

export default class ScrollToTop extends React.Component {
  static propTypes = {
    center: PropTypes.bool,
    compact: PropTypes.bool,
    debug: PropTypes.string,
    settings: PropTypes.object,
    storybookVisible: PropTypes.bool,
  };

  static defaultProps = {
    center: false,
    compact: window.innerWidth < 768,
    settings: {},
    storybookVisible: false,
    debug: null,
  };

  constructor(props) {
    super(props);

    this.state = {
      hidden: true,
      isCompact: window.innerWidth < 768 || this.props.compact,
      scrollActive: false,
      lastOffset: 0,
    };
  }

  handleScrollEnd = () => {
    const { hidden } = this.state;
    const offset = window.pageYOffset;
    const activationOffset = 500;

    if (hidden && offset > activationOffset) this.setState({ hidden: false });
    if (!hidden && offset < activationOffset) this.setState({ hidden: true });
  };

  handleScrollStart = () => {
    if (!this.state.scrollActive) {
      this.setState({
        hidden: true,
        isCompact: window.innerWidth < 768 || this.props.compact,
        scrollActive: true,
        lastOffset: window.pageYOffset,
      });

      setTimeout(this.checkScrollEnded, 300);
    }
  };

  checkScrollEnded = () => {
    if (this.state.lastOffset === window.pageYOffset) {
      this.setState({ scrollActive: false });
    } else {
      this.setState({
        lastOffset: window.pageYOffset,
      });
      setTimeout(this.checkScrollEnded, 300);
    }
  };

  componentDidUpdate(_, prevState) {
    if (!this.state.scrollActive && prevState.scrollActive) {
      this.handleScrollEnd();
    }
  }

  componentDidMount() {
    window.addEventListener('scroll', this.handleScrollStart, true);
  }

  componentWillUnmount() {
    window.removeEventListener('scroll', this.handleScrollStart);
  }

  render() {
    const { settings, center, storybookVisible, debug } = this.props;
    const whatsappUrl =
      settings && settings.whatsappWidget && settings.whatsappWidget.isActive
        ? settings.whatsappWidget.whatsappUrl
        : undefined;

    return (
      <button
        className={cx(
          'btnWrapper',
          this.state.hidden ? 'hidden' : undefined,
          whatsappUrl || center ? 'center' : undefined,
          !this.state.isCompact ? styles.btnWrapperDesktop : undefined,
          this.state.isCompact ? styles.compact : undefined,
          storybookVisible ? 'storybook-visible' : undefined,
          debug ? `debug-${debug}` : undefined
        )}
        aria-label="Scrollt an den Seitenanfang"
        onClick={() =>
          window.scrollTo({
            top: 0,
            left: 0,
            behavior: 'smooth',
          })
        }
      >
        <span className={styles.textWrapper}>
          <span className={styles.label}>Nach oben</span>
          <img
            alt="Pfeil, der nach oben zeigt"
            className={styles.backToTopIcon}
            src={`${process.env.ASSET_ENV_HOST}/assets/img/icon_back_to_top.svg`}
          />
        </span>
      </button>
    );
  }
}
